import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit, HostListener, Inject } from '@angular/core';
import { EditForm } from '../../../../base/controlers/edit-form';
import { CustomerPortal } from '../../models/customer-portal';
import { LayoutTypeService } from '../../services/layout-type.service';
import { CustomerPortalService } from '../../services/customer-portal.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormGroup, FormControl, Validators, FormArray, AbstractControl } from '@angular/forms';
import { IFileStoreItem } from '../../../../documents/interfaces/IFileStoreItem';
import { basename } from 'path';
import { LayoutType } from '../../models/layout-type';
import { AfterFormPopulated, AfterSubmit, AfterNew, AfterInitialStateSet } from '../../../../interfaces/iedit-form';
import { DoorTypeService } from '../../services/door-type.service';
import { DoorType } from '../../models/door-type';
import { DecorTypeService } from '../../services/decor-type.service';
import { DecorService } from '../../services/decor.service';
import { DecorType } from '../../models/decor-type';
import { Decor } from '../../models/decor';
import { IFileInfo } from '../../../../directives/file-drop/interfaces/IFileInfo';
import { FileUploadService } from '../../../../directives/file-drop/file-upload.service';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { TranslateService } from '@ngx-translate/core';
import { MatChipListChange, MatDialog, MatDialogConfig, MatDialogRef, MatIconRegistry, MatTabChangeEvent } from '@angular/material';
import { InsideType } from '../../models/inside-type';
import { Inside, InsideItem } from '../../models/inside';
import { InsideTypeService } from '../../services/inside-type.service';
import { InsideService } from '../../services/inside.service';
import { Layout } from '../../models/layout';
import { LayoutService } from '../../services/layout.service';
import { HttpEventType } from '@angular/common/http';
import { getrelativeurl } from '../../../../../environments/environment';
import { BaseAutoCompleteService } from '../../../../services/base-auto-complete.service';
import { ReferenceAutoComplete } from '../../../../documents/document-reference/reference-auto-complete';
import { IQueryResult } from '../../../../base/interfaces/IQueryResult';
import { State } from '../../../../base/models/State';
import { LayoutLocation } from '../../models/layout-location';
import { StateHistory } from './state-history';
import { Stack } from '../../../../modules/shared/structures/stack/stack';
import { IPageInfo } from '../../../../base/interfaces/IPageInfo';
import { ImageBrowserElement } from '../../../../modules/shared/components/image-browser/selected-element';
import { OperationExecutingComponent } from '../../../../dialogs/operation-executing/operation-executing.component';
import { CachedFileService } from '../../../../directives/file-drop/cached-file-service';
import { EnviromentService } from '../../../../services/enviroment.service';
import { GetObjectKey } from '../../../../modules/shared/functions/core';
import { DOCUMENT } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { PixelService } from '../../../../modules/facebook-pixel/services/facebook-pixel/pixel.service';

@Component({
  selector: 'app-customer-portal',
  templateUrl: './customer-portal.component.html',
  styleUrls: ['./customer-portal.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class CustomerPortalComponent extends EditForm<CustomerPortal>  implements OnInit, AfterFormPopulated, AfterSubmit<CustomerPortal>, AfterNew<CustomerPortal>, AfterInitialStateSet {

  sideMenuOpen:boolean = false;
  imageSelectorLoading:boolean = false;
  customerSettings:Object;
  reportedState:string = null;

  private displayedDecorPages:number[] = [];
  public fbAddId = null;
  public featureCalculateEstimate = 'no';

  constructor(
    ns: ToastrService,          
    tr: TranslateService,
    r: Router,
    ds:CustomerPortalService,
    ar: ActivatedRoute,
    l:Location,   
    private layoutTypeService:LayoutTypeService,
    private layoutService:LayoutService,
    private doorTypeService:DoorTypeService,
    private cdRef:ChangeDetectorRef,
    private decorTypeService: DecorTypeService,
    private decorService: DecorService,
    private insideTypeService: InsideTypeService,
    private insideService: InsideService,    
    private autoCompleteService:BaseAutoCompleteService,
    private fileUploadService:FileUploadService,
    private dialog: MatDialog,
    private enviromentService:EnviromentService,
    @Inject(DOCUMENT) private document: Document,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private pixel: PixelService 
  ) {     
    super(ns,tr,r,ds,ar,l,'/plasard-measurement/customer/add',[
      {
        id: '2946cb0d-1f98-4c56-8a58-cfe7da4b0289',
        code:'layoutType',
        name: 'Izberite vrsto omare'
      },
      {
        id: 'c6102801-0b71-4ba3-8734-87347dd923a2',
        code:'layout',
        name: 'Izberite vrsto omare'
      },      
      {
        id: 'ae66f20b-8ada-42fb-a488-bc1539bdc7ba',
        code:'measurements',
        name: 'Vpišite dimenzije omare'
      },
      {
        id: '87d96006-7f27-4ca9-986d-8a13032c7861',
        code:'inside',
        name: 'Izberite notranjost omare'
      },
      {
        id: '6d721c50-5b61-4ce4-a7cb-957d558d8417',
        code:'doorType',
        name: 'Izberite izgled drsnih vrat'
      },      
      {
        id: '3534051e-f6b1-4933-bbbe-96aa716b4050',
        code:'outside',
        name: 'Izberite izgled drsnih vrat'
      },
      {
        id: '9e7a21f2-4ba2-4958-b911-af0fc23142cf',
        code:'customerInfo',
        name: 'Podatki stranke'
      },
      {
        id: 'bce23d25-f28f-4989-8c5d-d667a41a9f34',
        code:'offer',
        name: 'Informativni izračun'
      },
      {
        id: '2b15b95c-9a02-479b-98e3-84de70a8fb53',
        code:'finish',
        name: 'Zaključek'
      }      
    ]);  
    this.dimensionsLayout = new DimentionsLayout(0,0,0);

    this.matIconRegistry.addSvgIcon('plasard-logo',
    this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/logos/plasard.svg"));
  }
  private offserSubmitDialogConfig: MatDialogConfig;
  private offerSubmitDialog: MatDialogRef<OperationExecutingComponent,any> = null; 
  layoutTypes:IQueryResult<LayoutType>;
  layoutTypeItem:LayoutType;
  layoutSubTypeItem:LayoutType;
  layoutItem:LayoutType;
  layoutTypesPage = 1;
  layoutTypesPageSize = 5;
  layoutSubTypesPage = 1;  
  layoutTypesGapCloser = 0;
  layoutSubTypesPageSize = 5;
  layoutSubTypes:IQueryResult<LayoutType>;
  layoutSubTypesGapCloser = 0;
  layoutPage = 1;  
  layoutPageSize = 5;  
  layouts:IQueryResult<Layout> = null;
  doorTypes:DoorType[];
  doorTypesPage:IPageInfo;
  layoutGapCloser = 0;
  decorTypes:DecorType[];
  decors:Decor[];  
  insidePageSize:number = 12;
  insideItem:FormArray;
  insideItemLocation:LayoutLocation;
  doors:FormArray;
  doorsLocation:LayoutLocation;
  insideTypes:InsideType[];
  insideLocations: ReferenceAutoComplete[];
  offer:CustomerPortal;
  defaultInsides:Inside[];
  subStates?: State[];
  subState: string;
  prevSubState: string;
  subStateItem: State;
  stateHistory: Stack<StateHistory>;
  stateSubState:any;
  dimensionsLayout:DimentionsLayout;
  isInitialStateSet = false;
  measurmentPreviewWidth = 500;
  doorCountLeft: number[] = null
  doorCountCenter: number[] = null
  doorCountRight: number[] = null
  measurementSideWidth = 20;
  layoutSelectorImageSize = '210x300';
  esstimate=0;
  selectedInsideItems = new Map<string, InsideItem>();
  selectedDoorTypes = new Map<string, DoorType>();
  selectedDecorItems = new Map<string, Decor>();

  @HostListener("window:resize", []) updatePreviewWidth() {    
    // lg (for laptops and desktops - screens equal to or greater than 1200px wide)
    // md (for small laptops - screens equal to or greater than 992px wide)
    // sm (for tablets - screens equal to or greater than 768px wide)
    // xs (for phones - screens less than 768px wide)
  
    if (window.innerWidth >= 2000) {
      this.measurmentPreviewWidth = 500; // lg
    } else if (window.innerWidth >= 1200) {
      this.measurmentPreviewWidth = 400;//md
    } else if (window.innerWidth >= 992) {
      this.measurmentPreviewWidth = 400;//md
    } else if (window.innerWidth  >= 768) {
      this.measurmentPreviewWidth = 300;//sm
    } else if (window.innerWidth < 768) {
      this.measurmentPreviewWidth = 250;//xs
    }
    // set layoutSelectorImageSize
    if(window.innerWidth >= 1600){
      this.layoutSelectorImageSize = '210x300';
    }
    else {
      this.layoutSelectorImageSize = '210x170';
    }
  }  

  ngOnInit() {
    let now = new Date();    
    let date = new Date(now.getDate());
    let validTill = new Date(now.getDate()+7);
    let deliveryDate = new Date(now.setMonth(now.getMonth() + 2));
    this.updatePreviewWidth();

    this.stateHistory = new Stack<StateHistory>();
    this.stateSubState = {};

    this.form = new FormGroup({
      id: new FormControl(),
      description: new FormControl(),
      stateId: new FormControl(),
      code: new FormControl(),
      name: new FormControl(),
      plasardLayoutTypeId: new FormControl(null),
      plasardLayoutSubTypeId: new FormControl(null),
      plasardLayoutId: new FormControl(null),
      drawerInsideId: new FormControl(null),
      shelfInsideId: new FormControl(null),
      heightCenter: new FormControl(0),
      widthCenter: new FormControl(0),
      depthCenter: new FormControl(0),      
      heightLeft: new FormControl(0),
      widthLeft: new FormControl(0),
      depthLeft: new FormControl(0),
      heightRight: new FormControl(0),
      widthRight: new FormControl(0),
      depthRight: new FormControl(0),                        
      noOfDoorsCenter: new FormControl(0),
      noOfDoorsLeft: new FormControl(0),
      noOfDoorsRight: new FormControl(0),
      email: new FormControl(null),
      address: new FormControl(null),
      cityId: new FormControl(null),
      city: new FormControl(null),
      telepohone: new FormControl(null),
      company: new FormControl(null),
      date: new FormControl(date),
      validTill: new FormControl(validTill),
      deliveryDate: new FormControl(deliveryDate),
      doorsLeft: new FormArray([]),
      doorsRight: new FormArray([]),
      doorsCenter: new FormArray([]),
      insidesLeft: new FormArray([]),
      insidesRight: new FormArray([]),
      insidesCenter: new FormArray([]),
      items: new FormArray([]),
      total: new FormControl(0)
    });

    this.loadLayoutTypePage(1);

    this.autoCompleteService.Query('Plasard-InsideLocation',null).subscribe(result => {
      if(result){
        this.insideLocations = result.payload;
      }
    });
    this.insideService.Filter(`isDefault eq true`,'code',null,1,5).subscribe(result => {
      if(result){
        this.defaultInsides = result.payload;
      }
    });

    this.form.controls['noOfDoorsLeft'].valueChanges.subscribe((val:number)=>{
      if(this.doorsLeft.value){
        this.doorsLeft.clear();
        this.insidesLeft.clear();        
      }      
      if(val && val>0){
        if (!(this.doorsLeft.value)){
          this.doorsLeft.setValue([]);
          this.insidesLeft.setValue([]);
        }
        for(let i=0;i<val;i++){
          this.doorsLeft.push(this.newDoor(LayoutLocation.Left));
          this.insidesLeft.push(this.newInside(LayoutLocation.Left));
        }
      }
      this.setDimensionsLayout();
      this.populateDefaultInsides(LayoutLocation.Left);
    });

    this.form.controls['noOfDoorsRight'].valueChanges.subscribe((val:number)=>{
      if(this.doorsRight.value){
        this.doorsRight.clear();
        this.insidesRight.clear();
      }      
      if(val && val>0){
        if (!(this.doorsRight.value)){
          this.doorsRight.setValue([]);
          this.insidesRight.setValue([]);
        }
        for(let i=0;i<val;i++){
          this.doorsRight.push(this.newDoor(LayoutLocation.Right));
          this.insidesRight.push(this.newInside(LayoutLocation.Right));
        }
      }
      this.setDimensionsLayout();
      this.populateDefaultInsides(LayoutLocation.Right);
    });   

    this.form.controls['noOfDoorsCenter'].valueChanges.subscribe((val:number)=>{
      if(this.doorsCenter.value){
        this.doorsCenter.clear();
        this.insidesCenter.clear();
      }      
      if(val && val>0){
        if (!(this.doorsCenter.value)){
          this.doorsCenter.setValue([]);
          this.insidesCenter.setValue([]);
        }
        for(let i=0;i<val;i++){
          this.doorsCenter.push(this.newDoor(LayoutLocation.Center));
          this.insidesCenter.push(this.newInside(LayoutLocation.Center));
        }
      }
      this.setDimensionsLayout();
      this.populateDefaultInsides(LayoutLocation.Center);
    });
    this.form.get('widthLeft').valueChanges.subscribe(value => {
      this.setDoorCount(DoorLocation.Left, value);
    });
    this.form.get('widthCenter').valueChanges.subscribe(value => {
      this.setDoorCount(DoorLocation.Center, value);
    });
    this.form.get('widthRight').valueChanges.subscribe(value => {
      this.setDoorCount(DoorLocation.Right, value);
    });    

    this.loadLayoutTypePage(1);

    this.autoCompleteService.Query('Plasard-InsideLocation',null).subscribe(result => {
      if(result){
        this.insideLocations = result.payload;
      }
    });

    this.loadDoorTypes();
    this.decorTypeService.GetAll('code').subscribe((data)=>{
      if(data){
        this.decorTypes = data.payload;
      }
      this.decorService.GetAll("").subscribe((data)=>{
        if(data){
          this.decors = data.payload;
          if(this.decorTypes && this.decorTypes.length>0){
            this.onDecorTypeSelected(this.decorTypes[0]);
          }        
        }
      })      
    })
    this.insideTypeService.GetAll().subscribe((data)=>{
      if(data){
        this.insideTypes = data.payload;
        if(this.insideTypes && this.insideTypes.length>0){
          this.onInsideTypeSelected(this.insideTypes[0]);
        }
      }
    });

    super.ngOnInit();  
    this.enviromentService.getCustomerSettings().subscribe(result => {
      this.customerSettings = result;
    });

    this.activatedRoute.queryParams.subscribe(params => {
      if(params.fbAddId !== undefined){
        this.fbAddId = params.fbAddId;
        this.pixel.track('ViewContent', {
          ad_id: params.fbAddId,
          content_name: 'knofigurator'
        });
      }
      if(params.featureCalculateEstimate !== undefined){
        this.featureCalculateEstimate = params.featureCalculateEstimate;
      }
    });
    this.form.valueChanges.subscribe(value => {
      this.calculateEstimate();
    })
  }  
  onTest(){
    console.log('pošta', this.form);
  }
  onTestDialog() {    
    this.offserSubmitDialogConfig = new MatDialogConfig();
    this.offserSubmitDialogConfig.disableClose = true;
    this.offserSubmitDialogConfig.backdropClass = 'sendpdf-backdrop';
    this.offserSubmitDialogConfig.hasBackdrop = true;
    this.offserSubmitDialogConfig.data = {
      title: 'plasardMeasurement.operationExecuting',
      message: 'plasardMeasurement.sendingOffer'
    };
    this.offserSubmitDialogConfig.width = '600px';
    this.offerSubmitDialog = this.dialog.open(OperationExecutingComponent, this.offserSubmitDialogConfig);
    setTimeout(() => {
      //this.offerSubmitDialog.close();
    }, 50000);
  }

  getNumberOfDoors(location: LayoutLocation){
    let noOfDoors:number = 0;
    if(location === LayoutLocation.Left){
      noOfDoors = this.form.get('noOfDoorsLeft').value;
    }
    else if(location === LayoutLocation.Right){
      noOfDoors = this.form.get('noOfDoorsRight').value;
    }
    else if(location === LayoutLocation.Center){
      noOfDoors = this.form.get('noOfDoorsCenter').value;
    }
    return noOfDoors;
  }
  getNumberOfPanels(){
    var door = <FormGroup>this.doors.at(this.selectedDoorIndex);
    if(door)
    {
      if(door.controls.plasardDoorType.value.code === '0'){
        return 1;
      }
      else if(door.controls.plasardDoorType.value.code === '1'){
        return 2;
      }
      else if(door.controls.plasardDoorType.value.code === '2'){
        return 3;
      }    
      else if(door.controls.plasardDoorType.value.code === '3'){
        return 3;
      }    
      else if(door.controls.plasardDoorType.value.code === '4'){
        return 5;
      } 
      else if(door.controls.plasardDoorType.value.code === '5'){
        return 5;
      }
      else {
        return 0;
      }    
    }
    else {
      return 0;
    }
  }
  populateDefaultInsides(location: LayoutLocation){
    let insides:FormArray = null;
    let noOfDoors:number = 0;
    if(location === LayoutLocation.Left){
      insides = this.form.get('insidesLeft') as FormArray;
      noOfDoors = this.form.get('noOfDoorsLeft').value
    }
    else if(location === LayoutLocation.Right){
      insides = this.form.get('insidesRight') as FormArray;
      noOfDoors = this.form.get('noOfDoorsRight').value
    }
    else if(location === LayoutLocation.Center){
      insides = this.form.get('insidesCenter') as FormArray;
      noOfDoors = this.form.get('noOfDoorsCenter').value
    }    
    if(insides){
      for(let d = 0;d<noOfDoors;d++){
        const insideItem:Inside = this.getDefaultInside(noOfDoors,d);
        const inside:FormGroup = <FormGroup>insides.at(d);
        if(inside && insideItem){
          let panel = `panel${1}Id`;
          let container = `panel${1}Container`;    

          var item = <any>insideItem
          this.addInsideItem(insideItem.id, <InsideItem>item);

          inside.controls[container].setValue(insideItem.id);       
          inside.controls[panel].setValue(insideItem.picture);
          inside.controls['insideId'].setValue(insideItem.id);
        }        
      }
    }
  }
  getDefaultInside(number:number, index:number){
    let ret:Inside = null;
    if(this.insideLocations && this.defaultInsides){
      const lid1 = this.insideLocations.find(f => f.name === '3.1');
      const lid2 = this.insideLocations.find(f => f.name === '2.1');
      const lid3 = this.insideLocations.find(f => f.name === '1');
      const lid4 = this.insideLocations.find(f => f.name === '2.2');
      const lid5 = this.insideLocations.find(f => f.name === '3.2');
      if(number===1){
        ret = this.defaultInsides.find(f => f.locationId == lid3.id);        
      }    
      else if(number===2){
        if(index === 0){
          ret = this.defaultInsides.find(f => f.locationId == lid2.id);        
        }
        if(index === 1){
          ret = this.defaultInsides.find(f => f.locationId == lid4.id);        
        }
      }    
      else if(number===3){
        switch(index){
          case 0:
            ret = this.defaultInsides.find(f => f.locationId == lid2.id);        
            break;
          case 1:
            ret = this.defaultInsides.find(f => f.locationId == lid3.id);        
            break;
          case 2:
            ret = this.defaultInsides.find(f => f.locationId == lid4.id);        
            break;
        }
        //insideFilter = `locationId in (${lid2.id},${lid4.id},${lid3.id})`
      }
      else if(number===4){
        switch(index){
          case 0:
            ret = this.defaultInsides.find(f => f.locationId == lid1.id);        
            break;
          case 1:
            ret = this.defaultInsides.find(f => f.locationId == lid2.id);        
            break;  
          case 2:
            ret = this.defaultInsides.find(f => f.locationId == lid4.id);        
            break;  
          case 3:
            ret = this.defaultInsides.find(f => f.locationId == lid5.id);        
            break;      
        }
        //insideFilter = `locationId in (${lid1.id},${lid2.id},${lid4.id},${lid5.id})`
      }            
      else if(number===5){
        switch(index){
          case 0:
            ret = this.defaultInsides.find(f => f.locationId == lid1.id);        
            break;
          case 1:
            ret = this.defaultInsides.find(f => f.locationId == lid2.id);        
            break;
          case 2:
            ret = this.defaultInsides.find(f => f.locationId == lid3.id);        
            break;
          case 3:
            ret = this.defaultInsides.find(f => f.locationId == lid4.id);        
            break;
          case 4:
            ret = this.defaultInsides.find(f => f.locationId == lid5.id);        
            break;        
        }
      }
    }
    return ret;
  }
  setDimensionsLayout(){
    let type = this.layoutTypeItem;
    if(this.layoutSubTypeItem){
      type = this.layoutSubTypeItem;
    }
    if(type){
      if(type.outsideLeft && type.outsideRight && type.outsideCenter){
        this.dimensionsLayout.left = 33;
        this.dimensionsLayout.right = 33;
        this.dimensionsLayout.center = 33;
        this.measurementSideWidth = 20;
      }
      else if(!type.outsideLeft && type.outsideRight && type.outsideCenter){
        this.dimensionsLayout.left = 0;
        this.dimensionsLayout.right = 50;
        this.dimensionsLayout.center = 50;
        this.measurementSideWidth = 30;
      }
      else if(type.outsideLeft && !type.outsideRight && type.outsideCenter){
        this.dimensionsLayout.left = 50;
        this.dimensionsLayout.right = 0;
        this.dimensionsLayout.center = 50;
        this.measurementSideWidth = 30;
      }
      else if(type.outsideLeft && type.outsideRight && !type.outsideCenter){
        this.dimensionsLayout.left = 50;
        this.dimensionsLayout.right = 50;
        this.dimensionsLayout.center = 0;
        this.measurementSideWidth = 30;
      }
      else if(type.outsideLeft && !type.outsideRight && !type.outsideCenter){
        this.dimensionsLayout.left = 100;
        this.dimensionsLayout.right = 0;
        this.dimensionsLayout.center = 0;
        this.measurementSideWidth = 40;
      }
      else if(!type.outsideLeft && !type.outsideRight && type.outsideCenter){
        this.dimensionsLayout.left = 0;
        this.dimensionsLayout.right = 0;
        this.dimensionsLayout.center = 100;
        this.measurementSideWidth = 40;
      }
      else if(!type.outsideLeft && type.outsideRight && !type.outsideCenter){
        this.dimensionsLayout.left = 0;
        this.dimensionsLayout.right = 100;
        this.dimensionsLayout.center = 0;
        this.measurementSideWidth = 40;
      }
      else if(!type.outsideLeft && !type.outsideRight && !type.outsideCenter){
        this.dimensionsLayout.left = 100;
        this.dimensionsLayout.right = 0;
        this.dimensionsLayout.center = 0;
        this.measurementSideWidth = 40;
      }    
    }
  }
  onAterNew(model: CustomerPortal): CustomerPortal {
    if(!model.items){
      model.items = [];
    }
    return model;
  }  
  get doorsLeft() : FormArray {
    return this.form.get("doorsLeft") as FormArray
  }
  get doorsRight() : FormArray {
    return this.form.get("doorsRight") as FormArray
  }  
  get doorsCenter() : FormArray {
    return this.form.get("doorsCenter") as FormArray
  }    
  newDoor(layoutLocation: LayoutLocation): FormGroup {
    let portalId = <string>(this.form.controls['id'].value);
    return new FormGroup({
      id: new FormControl('00000000-0000-0000-0000-000000000000'),
      layoutLocation: new FormControl(layoutLocation),
      customerPortalId: new FormControl(portalId),
      plasardDoorTypeId: new FormControl(this.doorTypes[0].id),
      plasardDoorType: new FormControl(this.doorTypes[0]),
      panel1Id: new FormControl(),
      panel2Id: new FormControl(),
      panel3Id: new FormControl(),
      panel4Id: new FormControl(),
      panel5Id: new FormControl(),
      item1Id: new FormControl(),
      item2Id: new FormControl(),
      item3Id: new FormControl(),
      item4Id: new FormControl(),
      item5Id: new FormControl(),      
      panel1Container: new FormControl(),
      panel2Container: new FormControl(),
      panel3Container: new FormControl(),
      panel4Container: new FormControl(),
      panel5Container: new FormControl()
    })
  }  
  get insidesLeft() : FormArray {
    return this.form.get("insidesLeft") as FormArray
  }
  get insidesRight() : FormArray {
    return this.form.get("insidesRight") as FormArray
  }
  get insidesCenter() : FormArray {
    return this.form.get("insidesCenter") as FormArray
  }
  newInside(layoutLocation: LayoutLocation): FormGroup {
    let portalId = <string>(this.form.controls['id'].value);
    const doorType = this.doorTypes.find(f => f.code === '0');
    return new FormGroup({
      id: new FormControl('00000000-0000-0000-0000-000000000000'),
      layoutLocation: new FormControl(layoutLocation),
      customerPortalId: new FormControl(portalId),
      plasardDoorTypeId: new FormControl(doorType.id),
      plasardDoorType: new FormControl(doorType),
      insideId: new FormControl(),
      panel1Id: new FormControl(),
      panel2Id: new FormControl(),
      panel3Id: new FormControl(),
      panel4Id: new FormControl(),
      panel5Id: new FormControl(),
      panel1Container: new FormControl(),
      panel2Container: new FormControl(),
      panel3Container: new FormControl(),
      panel4Container: new FormControl(),
      panel5Container: new FormControl()
    })
  }  
  _canMoveToNext:boolean = false;
  canMoveToNextSubState:boolean = false;
  lastSubState:boolean = false;
  firstSubState:boolean = false;

  generatePdf(){    
    const div = document.getElementById("pdfReport");    
    const options = {backgroundColor: "white", height: div.clientHeight, width: div.clientWidth, useCORS: true};

    

    html2canvas(div, options).then((canvas) => {
      const pageWidth = 208;
      const pageHeight = 295;
      const imgHeight = canvas.height * pageWidth / canvas.width;
      const imgWidth = pageWidth;
      const heightLeft = imgHeight;      
      var position = 0;
        //Initialize JSPDF
        let doc = new jsPDF("p", "mm", "a4",1);
        //Converting canvas to Image
        let imgData = canvas.toDataURL("image/jpeg", 0.5);
        var width = doc.internal.pageSize.getWidth();
        var height = doc.internal.pageSize.getHeight();        
        //Add image Canvas to PDF
        doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight,undefined,'SLOW');

        // const scale = 1;
        // const viewport = page.getViewport(scale);        
        // const context = canvas.getContext('2d');

        let pdfOutput = doc.output();
        

        // using ArrayBuffer will allow you to put image inside PDF
        let buffer = new ArrayBuffer(pdfOutput.length);
        let array = new Uint8Array(buffer);
        for (let i = 0; i < pdfOutput.length; i++) {
            array[i] = pdfOutput.charCodeAt(i);
        }

        //Name of pdf
        const fileName = "ponudba.pdf";
        // Make file
        doc.save(fileName);
    });    
  }
  uploadFile(blob:File){
    
    this.fileUploadService.UploadOne(blob,this.offer.id,null,'ponudba.pdf').subscribe(file => {
      if(file){
        if(file.type === HttpEventType.Response){
          this.offerSubmitDialog.close();
          if(file.body){
            const fileInfo:IFileInfo = <IFileInfo>file.body;
            if(fileInfo){
              (<CustomerPortalService>this.dataService).SendEmail(this.offer, fileInfo).subscribe(_ => {                                
                const redirect = GetObjectKey(this.customerSettings,'customerPortalRedirect');
                this.notificationsService.success("Ponudba uspešno poslana", "Hvala");
                if(redirect){
                  //this.document.location.href = redirect; //bbb
                }
                else {
                  this.reload();
                }                              
              }, error => {                
                this.notificationsService.error("Napaka pri pošiljanju ponudbe", "Napaka");
                this.reload();
              });
            }
          }
        }
      }
    }, error => {
      this.offerSubmitDialog.close();
      this.notificationsService.error("Napaka pri pripravi ponudbe", "Napaka");
      console.log(error);
    });
  }
  createPdf(){
    (<CustomerPortalService>this.dataService).GeneratePdf(this.offer).subscribe(res => {

      if(res && res.payload && res.payload.export){
        console.log('download link', res.payload.export.link);
        //this.downloadLink(res.payload.export.link);
        window.open(res.payload.export.link, '_blank');
        (<CustomerPortalService>this.dataService).SendEmail(this.offer, res.payload.export).subscribe(_ => {                                
          const redirect = GetObjectKey(this.customerSettings,'customerPortalRedirect');
          this.notificationsService.success("Ponudba uspešno poslana", "Hvala");
          //this.fileUploadService.Delete(res.payload.export).subscribe(_ => {})
          if(redirect){
            this.document.location.href = redirect;
          }
          else {
            this.reload();
          }                              
        }, error => {                
          console.log('error sending email', error);
          this.notificationsService.error("Napaka pri pošiljanju ponudbe", "Napaka");
          this.reload();
        });
      }
      else {
        this.offerSubmitDialog.close();
        this.notificationsService.error("Napaka pri pripravi ponudbe", "Napaka");
      }
    }, error => {
      this.offerSubmitDialog.close();
      this.notificationsService.error("Napaka pri pripravi ponudbe", "Napaka");
      console.log(error);
    })
  }
  downloadLink(url: string){
    window.open(url, "_blank");
  }
  savePdf(){
    const div = document.getElementById("pdfReport");
    const fileName = "ponudba.pdf";
    const options = {backgroundColor: "white", height: div.clientHeight, width: div.clientWidth, useCORS: true};

    html2canvas(div, options).then((canvas) => {
      var divHeight = div.clientHeight;
      var divWidth = div.clientWidth;
      var ratio = divHeight / divWidth;
      const pageWidth = 208;
      const pageHeight = 295;
      var position = 0;
        //Initialize JSPDF
        let doc = new jsPDF("p", "mm", "a4");
        //Converting canvas to Image
        let imgData = canvas.toDataURL("PNG",0.3);
        var width = doc.internal.pageSize.getWidth();
        var height = doc.internal.pageSize.getHeight();        
        var docRatio = height / width;
        height = ratio * width;
        //Add image Canvas to PDF
        doc.addImage(imgData, 'PNG', 0, position, width, height);
        const data = doc.output('blob');


        setTimeout(() => {
          this.uploadFile(data);      
        }, 500);
    });    
  }
  savePdf1(){
    const div = document.getElementById("pdfReport");
    const fileName = "ponudba.pdf";
    const options = {backgroundColor: "white", height: div.clientHeight, width: div.clientWidth, useCORS: true};

    html2canvas(div, options).then((canvas) => {
      const pageWidth = 208;
      const pageHeight = 295;
      var position = 0;
        //Initialize JSPDF
        let doc = new jsPDF("p", "mm", "a4");
        const imgHeight = doc.internal.pageSize.getWidth();
        const imgWidth = canvas.width * pageWidth / canvas.width;  
        //Converting canvas to Image
        let imgData = canvas.toDataURL("SVG",0.3);        
        var width = doc.internal.pageSize.getWidth();
        var height = doc.internal.pageSize.getHeight();        
        //Add image Canvas to PDF
        doc.addImage(imgData, 'SVG', 0, position, imgWidth, imgHeight);
        const data = doc.output('blob');


        setTimeout(() => {
          this.uploadFile(data);      
        }, 500);
    });    
  }  
  ponduba(){
    const div = document.getElementById("pdfReport");
    const fileName = "ponudba.pdf";
    const options = {backgroundColor: "white", height: div.clientHeight, width: div.clientWidth, useCORS: true};

    html2canvas(div, options).then((canvas) => {
      const pageWidth = 208;
      const pageHeight = 295;
      const imgHeight = canvas.height * pageWidth / canvas.width;
      const imgWidth = pageWidth;
      const heightLeft = imgHeight;      
      var position = 0;
        //Initialize JSPDF
        let doc = new jsPDF("p", "mm", "a4");
        //Converting canvas to Image
        let imgData = canvas.toDataURL("image/jpeg",0.3);
        var width = doc.internal.pageSize.getWidth();
        var height = doc.internal.pageSize.getHeight();        
        //Add image Canvas to PDF
        doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);

        let pdfOutput = doc.output();
        // using ArrayBuffer will allow you to put image inside PDF
        let buffer = new ArrayBuffer(pdfOutput.length);
        let array = new Uint8Array(buffer);
        for (let i = 0; i < pdfOutput.length; i++) {
            array[i] = pdfOutput.charCodeAt(i);
        }
        //generate pdf
        const data = doc.output('blob');
        //const blobUrl = URL.createObjectURL(data);
        //const immageArray = this.convertDataURIToBinary(blobUrl);

        setTimeout(() => {
          this.uploadFile(data);      
        }, 800);
    });    
  }
  convertDataURIToBinary(dataURI) {
    const BASE64_MARKER = ';base64,';
    var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    var base64 = dataURI.substring(base64Index);
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));
  
    for(var i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }
  loadLayoutPage(page:number, allowMoveNext:boolean){
    this.layoutPage = page;
    const layoutTypeId = this.form.get('plasardLayoutTypeId').value;
    const layoutTypeSubId = this.form.get('plasardLayoutSubTypeId').value;
    const parentid = layoutTypeSubId?layoutTypeSubId:layoutTypeId;
    const filter = `plasardLayoutTypeId eq ${parentid}`	  

    this.layoutService.Filter(filter,"code",null,this.layoutPage, this.layoutPageSize).subscribe(layouts => {
      if(layouts){          
        this.layouts = layouts;
        if(page === 1 && allowMoveNext && layouts.payload.length === 0){ // če ni postavitev gremo naprej          
          this.stateHistory.pop(); // remove current;
          this.moveToNext();
        }
        else {
          this.layoutGapCloser = ((100 - (layouts.payload.length*20)) / 2) - 7
        }
      }
    });
  }
  loadLayoutTypePage(page:number){
    this.layoutTypesPage=page;
    this.layoutTypeService.Filter("parentTypeId eq null and stateId ne null","code",null,this.layoutTypesPage,this.layoutTypesPageSize).subscribe((data)=>{
      if(data){
        if(data.payload){
          this.layoutTypesGapCloser = ((100 - (data.payload.length*20)) / 2) - 7;
        }
        this.layoutTypes = data;
      }
    })    
  }
  loadLayoutSubTypePage(page:number, parentId:string){
    this.layoutSubTypesPage=page;
    this.layoutTypeService.Filter(`parentTypeId eq ${parentId}`,"code",null,this.layoutSubTypesPage,this.layoutSubTypesPageSize).subscribe((data)=>{
      if(data){
        if(data.payload){
          this.layoutSubTypesGapCloser = ((100 - (data.payload.length*20)) / 2) - 7
        }
        this.layoutSubTypes = data;
      }
    })    
  }
  onRestart(){
    this.reload();
  }  
  onBack(){
    if(this.stateHistory.size>0){
      let prevState = this.stateHistory.size>1?this.stateHistory.pop():this.stateHistory.peek();      
      // if(prevState.stateId === 'customerInfo'){
      //   prevState = this.stateHistory.pop();
      // }
      if(prevState.stateId === this.state && prevState.subStateId === this.subState) { // move one back if current
        prevState = this.stateHistory.size>1?this.stateHistory.pop():this.stateHistory.peek();
      }      

      if(prevState){
        if(prevState.stateId){
          this.setState(prevState.stateId);
          this.initSubStates(this.stateSubState[prevState.stateId]);
        }
        if(prevState.subStateId){
          this.setSubState(prevState.subStateId);
        }
        else {
          this.initSubStates(null);
        }
        this.updateValidators();
      }
    }
  }
  onPrevSubState(stateId:string){
    const current: State = this.subStates.find(f => f.code === stateId);
    if(stateId){
      let idx = this.subStates.indexOf(current);
      if(current && idx > 0){
        idx--;
        this.prevSubState = this.subStates[idx].code;
      }
      else {
        this.prevSubState = null;        
      }
    }
    else {
      this.lastSubState = false;
      this.firstSubState = false;
      this.prevSubState = null;
      this.subState = null;
    }
    
  }
  pushStateHistoryIfNotExsists(stateId:string, subStateId:string){
    const item = new StateHistory(stateId, subStateId);
    if(!this.stateHistory.exsists(item)){
      this.pushStateHistory(stateId, subStateId);
    }
  }
  pushStateHistory(stateId:string, subStateId:string){    
    const last = this.stateHistory.peek();
    if(last){
      if(last.stateId !== stateId || last.subStateId !== subStateId){
        if(subStateId && last.stateId !== 'layoutType' && last.stateId == stateId && !last.subStateId) {       
          this.stateHistory.pop(); // remove root state;        
        }
        if(!(last.stateId === stateId && last.subStateId && !subStateId)){
          this.stateHistory.push(new StateHistory(stateId,subStateId));
        }          
      }      
    }
    else if(!last){
      this.stateHistory.push(new StateHistory(stateId,subStateId));
    }
  }
  nextSubState(stateId:string){    
    let s: State = stateId?this.subStates.find(f => f.code === stateId):this.subStates[0];        
    if(s){
      let idx = this.subStates.indexOf(s);      
      if(idx >= 0 && idx < this.subStates.length-1){
        s = this.subStates[idx+1];
      }
    }

    if(s){
      this.setSubState(s.code);
      //this.stateHistory.push(new StateHistory(this.state, s.code));
      this.pushStateHistory(this.state, s.code);
    }
  }
  setSubState(stateId:string){
    const s: State = this.subStates.find(f => f.code === stateId);    
    if(s){
      let idx = this.subStates.indexOf(s);
      this.prevSubState = stateId;
      this.subStateItem = s;
      this.subState = s.code
      this.lastSubState = idx === this.subStates.length - 1;
      this.firstSubState = idx === 0;
      if(this.lastSubState){
        this.canMoveToNextSubState = false;
      }
      else {
        this.canMoveToNextSubState = true;
      }            
    }
    this.initSubState(stateId);
  }
  initSubState(subStateId:string){
    if(this.state === 'outside' && subStateId === 'outsideLeft'){
      this.doors = this.doorsLeft;
      this.doorsLocation = LayoutLocation.Left;
      this.selectedDoorIndex = 0;
      this.selectedPanelIndex = 1;
    }
    else if(this.state === 'outside' && subStateId === 'outsideRight'){
      this.doors = this.doorsRight;
      this.doorsLocation = LayoutLocation.Right;
      this.selectedDoorIndex = 0;
      this.selectedPanelIndex = 1;
    }    
    else if(this.state === 'outside' && subStateId === 'outsideCenter'){
      this.doors = this.doorsCenter;
      this.doorsLocation = LayoutLocation.Center;
      this.selectedDoorIndex = 0;
      this.selectedPanelIndex = 1;
    }    
    if(this.state === 'doorType' && subStateId === 'outsideLeft'){
      this.doors = this.doorsLeft;
      this.doorsLocation = LayoutLocation.Left;
      this.selectedDoorIndex = 0;
      this.selectedPanelIndex = 1;
    }
    else if(this.state === 'doorType' && subStateId === 'outsideRight'){
      this.doors = this.doorsRight;
      this.doorsLocation = LayoutLocation.Right;
      this.selectedDoorIndex = 0;
      this.selectedPanelIndex = 1;
    }    
    else if(this.state === 'doorType' && subStateId === 'outsideCenter'){
      this.doors = this.doorsCenter;
      this.doorsLocation = LayoutLocation.Center;
      this.selectedDoorIndex = 0;
      this.selectedPanelIndex = 1;
    }   

    if(this.state === 'inside' && subStateId === 'insideLeft'){
      this.insideItem = this.insidesLeft;
      this.insideItemLocation = LayoutLocation.Left;
      this.onSelectedInsidePanel(0,1);
    }
    else if(this.state === 'inside' && subStateId === 'insideRight'){
      this.insideItem = this.insidesRight;
      this.insideItemLocation = LayoutLocation.Right;
      this.onSelectedInsidePanel(0,1);
    }    
    else if(this.state === 'inside' && subStateId === 'insideCenter'){
      this.insideItem = this.insidesCenter;
      this.insideItemLocation = LayoutLocation.Center;
      this.onSelectedInsidePanel(0,1);
    }       
    this.cdRef.detectChanges();     
  }
  moveToNext(){
    if(this.canMoveToNext()){
      this.preStateChange(this.state, this.subState);
      this.setState(this.nextState);
      //this.stateHistory.push(new StateHistory(this.state, null));
      this.pushStateHistory(this.state, null);
    }
  }
  canMoveToNext(){      
    //!(form.valid && form.controls['plasardLayoutTypeId'].value)
    let ret:boolean = this.form.valid;
    switch(this.state){
      case 'layoutType':
        ret = ret && this.form.controls['plasardLayoutTypeId'].value;
        break;
      case 'layout':
        if(this.layouts != null && this.layouts.payload && this.layouts.payload.length>0){
          ret = ret && this.form.controls['plasardLayoutId'].value;
          ret = ret && this.layoutTypeItem !== null;
        }        
        break;
      case 'doorType':
        this.doorsLeft.controls.forEach(door => {
          ret = ret && door.value && door.value.plasardDoorTypeId;
        });    
        ret = ret && this.doorTypes && this.doorTypes.length > 0;
        this.doorsRight.controls.forEach(door => {
          ret = ret && door.value && door.value.plasardDoorTypeId;
        });            
        this.doorsCenter.controls.forEach(door => {
          ret = ret && door.value && door.value.plasardDoorTypeId;
        });                    
        break;
      case 'outside':
        ret = ret && this.doorPanelSet(LayoutLocation.Left);
        ret = ret && this.doorPanelSet(LayoutLocation.Right);
        ret = ret && this.doorPanelSet(LayoutLocation.Center);
        break;        
      case 'inside':
        ret = ret && this.InsideSet(LayoutLocation.Left);
        ret = ret && this.InsideSet(LayoutLocation.Right);
        ret = ret && this.InsideSet(LayoutLocation.Center);
        break;                
    }
    return ret;
  }
  get nextStateName(): string {
    let ret :string = null;
    if(this.states){
      let state = this.states.find(f=>f.code === this.nextState);
      if(state){
        ret = state.name;
      }
    }
    return ret;
  }
  countdownInterval = null;
  updateValidators(){
    switch(this.state){
      case 'layoutType':
          this.form.get('plasardLayoutTypeId').setValidators([Validators.required]);
          this.form.get('heightLeft').clearValidators();
          this.form.get('widthLeft').clearValidators();
          this.form.get('depthLeft').clearValidators();
          this.form.get('heightRight').clearValidators();
          this.form.get('widthRight').clearValidators();
          this.form.get('depthRight').clearValidators();
          this.form.get('heightCenter').clearValidators();
          this.form.get('widthCenter').clearValidators();
          this.form.get('depthCenter').clearValidators();                    
          this.form.get('noOfDoorsCenter').clearValidators();
          this.form.get('noOfDoorsLeft').clearValidators();
          this.form.get('noOfDoorsRight').clearValidators();
          this.form.get('email').clearValidators();
          this.form.get('telepohone').clearValidators();
          
          this.form.get('heightLeft').setErrors(null);
          this.form.get('widthLeft').setErrors(null);
          this.form.get('depthLeft').setErrors(null);
          this.form.get('heightRight').setErrors(null);
          this.form.get('widthRight').setErrors(null);
          this.form.get('depthRight').setErrors(null);
          this.form.get('heightCenter').setErrors(null);
          this.form.get('widthCenter').setErrors(null);
          this.form.get('depthCenter').setErrors(null);                    
          this.form.get('noOfDoorsCenter').setErrors(null);
          this.form.get('noOfDoorsLeft').setErrors(null);
          this.form.get('noOfDoorsRight').setErrors(null);          
          this.form.get('email').setErrors(null);
          this.form.get('telepohone').setErrors(null);
          this.nextState = 'layout';          
        break;
        case 'layout':
          this.form.get('plasardLayoutTypeId').setValidators([Validators.required]);
          this.form.get('heightLeft').clearValidators();
          this.form.get('widthLeft').clearValidators();
          this.form.get('depthLeft').clearValidators();
          this.form.get('heightRight').clearValidators();
          this.form.get('widthRight').clearValidators();
          this.form.get('depthRight').clearValidators();
          this.form.get('heightCenter').clearValidators();
          this.form.get('widthCenter').clearValidators();
          this.form.get('depthCenter').clearValidators();                    
          this.form.get('noOfDoorsCenter').clearValidators();
          this.form.get('noOfDoorsLeft').clearValidators();
          this.form.get('noOfDoorsRight').clearValidators();
          this.form.get('email').clearValidators();
          this.form.get('telepohone').clearValidators();
          
          this.form.get('heightLeft').setErrors(null);
          this.form.get('widthLeft').setErrors(null);
          this.form.get('depthLeft').setErrors(null);
          this.form.get('heightRight').setErrors(null);
          this.form.get('widthRight').setErrors(null);
          this.form.get('depthRight').setErrors(null);
          this.form.get('heightCenter').setErrors(null);
          this.form.get('widthCenter').setErrors(null);
          this.form.get('depthCenter').setErrors(null);                    
          this.form.get('noOfDoorsCenter').setErrors(null);
          this.form.get('noOfDoorsLeft').setErrors(null);
          this.form.get('noOfDoorsRight').setErrors(null);
          this.form.get('email').setErrors(null);
          this.form.get('telepohone').setErrors(null);
          this.nextState = 'measurements';          
        break;
      case 'measurements':
          this.form.get('plasardLayoutTypeId').clearValidators();
          if(this.dimensionsLayout.left){
            this.form.get('heightLeft').setValidators([Validators.required,Validators.min(120),Validators.required,Validators.max(340)]);
            this.form.get('widthLeft').setValidators([Validators.required,Validators.min(130),Validators.required,Validators.max(500)]);
            this.form.get('depthLeft').setValidators([Validators.required,Validators.min(45),Validators.required,Validators.max(75)]);  
            this.form.get('noOfDoorsLeft').setValidators([Validators.required,Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$'),Validators.min(0),Validators.max(5)]);
          }
          if(this.dimensionsLayout.center){
            this.form.get('heightCenter').setValidators([Validators.required,Validators.min(120),Validators.required,Validators.max(340)]);
            this.form.get('widthCenter').setValidators([Validators.required,Validators.min(130),Validators.required,Validators.max(500)]);
            this.form.get('depthCenter').setValidators([Validators.required,Validators.min(45),Validators.required,Validators.max(75)]);
            this.form.get('noOfDoorsCenter').setValidators([Validators.required,Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$'),Validators.min(0),Validators.max(5)]);
          }
          if(this.dimensionsLayout.right){
            this.form.get('heightRight').setValidators([Validators.required,Validators.min(120),Validators.required,Validators.max(340)]);
            this.form.get('widthRight').setValidators([Validators.required,Validators.min(130),Validators.required,Validators.max(500)]);
            this.form.get('depthRight').setValidators([Validators.required,Validators.min(45),Validators.required,Validators.max(75)]);
            this.form.get('noOfDoorsRight').setValidators([Validators.required,Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$'),Validators.min(0),Validators.max(5)]);
          }                              
          this.nextState = 'inside';            
          break;        
      case 'doorType':
        this.form.get('email').clearValidators();
        this.form.get('email').setErrors(null);        
        this.form.get('address').clearValidators();
        this.form.get('address').setErrors(null);        
        this.form.get('city').clearValidators();
        this.form.get('city').setErrors(null);        
        this.form.get('name').clearValidators();
        this.form.get('name').setErrors(null);
        this.form.get('telepohone').clearValidators();
        this.form.get('telepohone').setErrors(null);
          this.nextState = 'outside';            
          break;          
      case 'outside':
        this.form.get('email').clearValidators();
        this.form.get('email').setErrors(null);        
        this.form.get('address').clearValidators();
        this.form.get('address').setErrors(null);        
        this.form.get('city').clearValidators();
        this.form.get('city').setErrors(null);        
        this.form.get('name').clearValidators();
        this.form.get('name').setErrors(null);
        this.form.get('telepohone').clearValidators();
        this.form.get('telepohone').setErrors(null);
          this.nextState = 'customerInfo';
          break;              
      case 'inside':
            this.form.get('email').clearValidators();
            this.form.get('email').setErrors(null);        
            this.form.get('address').clearValidators();
            this.form.get('address').setErrors(null);        
            this.form.get('city').clearValidators();
            this.form.get('city').setErrors(null);        
            this.form.get('name').clearValidators();
            this.form.get('name').setErrors(null);
            this.form.get('telepohone').clearValidators();
            this.form.get('telepohone').setErrors(null);
            this.nextState = 'doorType';            
            break;                        
      case 'customerInfo':
          this.form.get('plasardLayoutTypeId').clearValidators();
          this.form.get('heightLeft').clearValidators();
          this.form.get('widthLeft').clearValidators();
          this.form.get('depthLeft').clearValidators();
          this.form.get('heightRight').clearValidators();
          this.form.get('widthRight').clearValidators();
          this.form.get('depthRight').clearValidators();
          this.form.get('heightCenter').clearValidators();
          this.form.get('widthCenter').clearValidators();
          this.form.get('depthCenter').clearValidators();   
          this.form.get('noOfDoorsCenter').clearValidators();
          this.form.get('noOfDoorsLeft').clearValidators();
          this.form.get('noOfDoorsRight').clearValidators();
          this.form.get('email').setValidators([Validators.required,Validators.email]);        
          this.form.get('address').setValidators([Validators.required,Validators.required]);
          this.form.get('city').setValidators([Validators.required,Validators.required]);
          this.form.get('name').setValidators([Validators.required,Validators.required]);
          this.form.get('telepohone').setValidators([Validators.required,Validators.required]);
          this.nextState = 'finish';
          break;                  
      case 'finish':
          this.form.get('plasardLayoutTypeId').clearValidators();
          this.form.get('heightLeft').clearValidators();
          this.form.get('widthLeft').clearValidators();
          this.form.get('depthLeft').clearValidators();
          this.form.get('heightRight').clearValidators();
          this.form.get('widthRight').clearValidators();
          this.form.get('depthRight').clearValidators();
          this.form.get('heightCenter').clearValidators();
          this.form.get('widthCenter').clearValidators();
          this.form.get('depthCenter').clearValidators();   
          this.form.get('noOfDoorsCenter').clearValidators();
          this.form.get('noOfDoorsLeft').clearValidators();
          this.form.get('noOfDoorsRight').clearValidators();
          this.form.get('email').clearValidators();                
          this.form.get('telepohone').clearValidators();
          this.nextState = 'offer';          
          break;
      case 'offer':        
          this.nextState = null;
        break;
  
    }
    // setTimeout(() => {
    //   this.form.updateValueAndValidity();      
    // }, 1);
    this.cdRef.detectChanges();
  }  
  onAfterFormPopulated(){
    this.updateValidators();
    if(!this.isEdit){
      if(this.dimensionsLayout.left){
        if(!this.form.get('widthLeft').value){
          this.form.get('widthLeft').setValue(0);
        }
        if(!this.form.get('heightLeft').value){
          this.form.get('heightLeft').setValue(0);
        }
        if(!this.form.get('depthLeft').value){
          this.form.get('depthLeft').setValue(60);
        }        
      }
      if(this.dimensionsLayout.center){
        if(!this.form.get('widthCenter').value){
          this.form.get('widthCenter').setValue(0);
        }
        if(!this.form.get('heightCenter').value){
          this.form.get('heightCenter').setValue(0);
        }
        if(!this.form.get('depthCenter').value){
          this.form.get('depthCenter').setValue(60);
        }
      }
      if(this.dimensionsLayout.right){
        if(!this.form.get('widthRight').value){
          this.form.get('widthRight').setValue(0);
        }
        if(!this.form.get('heightRight').value){
          this.form.get('heightRight').setValue(0);
        }
        if(!this.form.get('depthRight').value){
          this.form.get('depthRight').setValue(60);
        }
      }
      //this.stateHistory.push(new StateHistory(this.state,null));
      //this.pushStateHistory(this.state, null);
    }    
    this.initState();
  }
  onAfterInitialStateSet(state: string): void {
    this.pushStateHistory(state, null);
  }  
  getlocationFilter(number:number, width:number = 0, depth:number = 0){
    let insideFilter=null;
    if(this.insideLocations){
      const lid1 = this.insideLocations.find(f => f.name === '3.1');
      const lid2 = this.insideLocations.find(f => f.name === '2.1');
      const lid3 = this.insideLocations.find(f => f.name === '1');
      const lid4 = this.insideLocations.find(f => f.name === '2.2');
      const lid5 = this.insideLocations.find(f => f.name === '3.2');
      if(number===1){
        insideFilter = `locationId in (${lid3.id})`
      }    
      else if(number===2){
        if(this.selectedInsideIndex === 0){
          insideFilter = `locationId in (${lid2.id})`
        }
        if(this.selectedInsideIndex === 1){
          insideFilter = `locationId in (${lid4.id})`
        }
      }    
      else if(number===3){
        switch(this.selectedInsideIndex){
          case 0:
            insideFilter = `locationId in (${lid2.id})`;
            break;
          case 1:
            insideFilter = `locationId in (${lid3.id})`;
            break;
          case 2:
            insideFilter = `locationId in (${lid4.id})`;  
            break;
        }
        //insideFilter = `locationId in (${lid2.id},${lid4.id},${lid3.id})`
      }
      else if(number===4){
        switch(this.selectedInsideIndex){
          case 0:
            insideFilter = `locationId in (${lid1.id})`;
            break;
          case 1:
            insideFilter = `locationId in (${lid2.id})`;
            break;  
          case 2:
            insideFilter = `locationId in (${lid4.id})`;
            break;  
          case 3:
            insideFilter = `locationId in (${lid5.id})`;
            break;      
        }
        //insideFilter = `locationId in (${lid1.id},${lid2.id},${lid4.id},${lid5.id})`
      }            
      else if(number===5){
        switch(this.selectedInsideIndex){
          case 0:
            insideFilter = `locationId in (${lid1.id})`
            break;
          case 1:
            insideFilter = `locationId in (${lid2.id})`
            break;
          case 2:
            insideFilter = `locationId in (${lid3.id})`
            break;
          case 3:
            insideFilter = `locationId in (${lid4.id})`
            break;
          case 4:
            insideFilter = `locationId in (${lid5.id})`
            break;        
        }
        //insideFilter = `locationId in (${lid1.id},${lid2.id},${lid3.id},${lid4.id},${lid5.id})`
      }
    }
    if(insideFilter){
      insideFilter += `and`;
      insideFilter += ` minWidth le ${Math.ceil(width/number)} and minDepth le ${depth}`;
    }
    return insideFilter;
  }
  initState() {        
    this.cdRef.detectChanges();
    let noOfDoorsLeft:number = 0;
    let noOfDoorsRight:number = 0;
    let noOfDoorsCenter:number = 0;
    this.initSubStates(null);
    switch(this.state){
      case 'finish':
        this.form.controls['code'].setValue('*');
        this.form.controls['total'].setValue(this.esstimate); 
        this.onSubmit()
        break;
      case 'inside':
        let insideSubStates: State[] = [];
        noOfDoorsLeft = this.form.get('noOfDoorsLeft').value;        
        noOfDoorsRight = this.form.get('noOfDoorsRight').value;
        noOfDoorsCenter = this.form.get('noOfDoorsCenter').value;
        if(noOfDoorsLeft>0){
          insideSubStates.push(
            {
              id: '06bc48d6-fdc2-4a00-aae2-db8746a96bd6',
              code:'insideLeft',
              name: 'Notranjost A'
            }  
          );
        }
        if(noOfDoorsCenter>0){
          insideSubStates.push(
            {
              id: '96b35a03-1f7d-40c1-b73c-35c9ebcf1ed6',
              code:'insideCenter',
              name: 'Notranjost B'
            }  
          );
        }           
        if(noOfDoorsRight>0){
          insideSubStates.push(
            {
              id: '4a8a3ecd-2c7e-4bfe-8b97-d4c1f9b08b05',
              code:'insideRight',
              name: 'Notranjost C'
            }  
          );
        }
        if(insideSubStates.length>1){
          this.initSubStates(insideSubStates)
          this.setSubState(insideSubStates[0].code);
          this.pushStateHistoryIfNotExsists(this.state,insideSubStates[0].code);
        }
        else {
          this.insideItem = this.insidesLeft;
          this.insideItemLocation = LayoutLocation.Left;
        }        
        this.onSelectedInsidePanel(0,1,true);
        break;
      case 'layout':
        this.loadLayoutPage(1, true);
        break;
      case 'layoutType':
        if(this.layoutTypeItem){
          this.onLayoutTypeSelected(this.layoutTypeItem);
        }        
        break;
      case 'outside':
        this.selectedDoorIndex = 0;
        this.selectedPanelIndex = 1;
        let outsideSubStates: State[] = [];
        this.onDecorTypeSelected(this.decorTypes[0]);
        noOfDoorsLeft = this.form.get('noOfDoorsLeft').value;        
        noOfDoorsRight = this.form.get('noOfDoorsRight').value;
        noOfDoorsCenter = this.form.get('noOfDoorsCenter').value;
        if(noOfDoorsLeft>0){
          outsideSubStates.push(
            {
              id: 'f60683bd-66aa-442f-98f6-6438c2c54764',
              code:'outsideLeft',
              name: 'Zunanjost A'
            }  
          );
        }
        if(noOfDoorsCenter>0){
          outsideSubStates.push(
            {
              id: '9fff6fce-414d-4429-b1df-154c7f77cf1a',
              code:'outsideCenter',
              name: 'Zunanjost B'
            }  
          );
        }           
        if(noOfDoorsRight>0){
          outsideSubStates.push(
            {
              id: '9fff6fce-414d-4429-b1df-154c7f77cf1a',
              code:'outsideRight',
              name: 'Zunanjost C'
            }  
          );
        }
        if(outsideSubStates.length>1){
          this.initSubStates(outsideSubStates)
          this.setSubState(outsideSubStates[0].code);
          this.pushStateHistoryIfNotExsists(this.state,outsideSubStates[0].code);
        }
        else {
          this.doors = this.doorsLeft;
          this.doorsLocation = LayoutLocation.Left;
        }        
        break;        
      case 'doorType':
        let doorTypeSubStates: State[] = [];
        noOfDoorsLeft = this.form.get('noOfDoorsLeft').value;        
        noOfDoorsRight = this.form.get('noOfDoorsRight').value;
        noOfDoorsCenter = this.form.get('noOfDoorsCenter').value;
        if(noOfDoorsLeft>0){
          doorTypeSubStates.push(
            {
              id: 'f60683bd-66aa-442f-98f6-6438c2c54764',
              code:'outsideLeft',
              name: 'Zunanjost A'
            }  
          );
        }
        if(noOfDoorsCenter>0){
          doorTypeSubStates.push(
            {
              id: '9fff6fce-414d-4429-b1df-154c7f77cf1a',
              code:'outsideCenter',
              name: 'Zunanjost B'
            }  
          );
        }           
        if(noOfDoorsRight>0){
          doorTypeSubStates.push(
            {
              id: '9fff6fce-414d-4429-b1df-154c7f77cf1a',
              code:'outsideRight',
              name: 'Zunanjost C'
            }  
          );
        }
        if(doorTypeSubStates.length>1){
          this.initSubStates(doorTypeSubStates)
          this.setSubState(doorTypeSubStates[0].code);
          this.pushStateHistoryIfNotExsists(this.state,doorTypeSubStates[0].code);
        }
        else {
          this.doors = this.doorsLeft;
          this.doorsLocation = LayoutLocation.Left;
        }
        break;
      default:
        break;
    }
    
    if(this.reportedState !== this.state){
      this.reportedState = this.state;
      this.pixel.trackCustom(`state-change-${this.state}`, {
        state: this.state
      });
    }
  }
  initSubStates(states?:State[], canmoveNext = false){
    if(states){
      this.subStates = states;
    }
    else {
      this.subStates = [];
    }
    this.subState = null;
    this.subStateItem = null;
    this.canMoveToNextSubState = false;
    this.prevSubState = null;
    this.stateSubState[this.state] = states;
    this.lastSubState = false;
    this.firstSubState = false;    
  }
  preStateChange(state:string, substate:string){
    if(state === 'customerinfo'){
      let description = '';
      if(this.layoutTypeItem){
        if(this.layoutTypeItem.outsideLeft && !this.layoutTypeItem.outsideCenter && !this.layoutTypeItem.outsideRight){
          description += `dimenzije:{{dimensionleft}}`;
        }
        else {
          if(this.layoutTypeItem.outsideLeft){
            description += `Dimenzije levo:{{dimensionleft}}`;
          }
          if(this.layoutTypeItem.outsideCenter){
            description += `\nDimenzije sredina:{{dimensioncenter}}`;
          }
          if(this.layoutTypeItem.outsideRight){
            description += `\nDimenzije desno:{{dimensionright}}`;
          }          
        }
        description += `\nPredali:{{drawers}}`;
        description += `\nPolice:{{shelves}}`;

        description += `\nZUNANJOST:`;
        description += `\n{{outsides}}`;

        description += `\nDODATKI:`;
        description += `\n{{additions}}`;        
      }
    }
  }
  setState(stateId:string){
    super.setState(stateId);
    this.onAfterFormPopulated();    
  }
  assets(file:string){
    return getrelativeurl(`assets/${file}`);
  }
  onSideNav(){
    this.sideMenuOpen = !(this.sideMenuOpen);
  }
  onLayoutTypeSubSelected(layoutSubType:LayoutType){    
    this.layoutSubTypeItem = layoutSubType;
    this.setDimensionsLayout();
    this.layouts = null;
    this.layoutItem = null;
    this.form.controls['plasardLayoutId'].setValue(null);
    if(layoutSubType){      
      this.form.controls['plasardLayoutSubTypeId'].setValue(layoutSubType.id);      
      setTimeout(() => {
        this.moveToNext();
      }, 50);              
    }
    //this.calculateEstimate(); 
  }
  onLayoutTypeSelected(layoutType:LayoutType){
    this.layoutTypeItem = layoutType;
    this.layoutSubTypeItem = null;
    this.layoutSubTypes = null;
    this.layoutItem = null;
    this.form.controls['plasardLayoutSubTypeId'].setValue(null);
    this.form.controls['plasardLayoutId'].setValue(null);
    this.setDimensionsLayout();
    this.initSubStates();
    this.layouts = null;
  
    if(layoutType){
      this.form.controls['plasardLayoutTypeId'].setValue(layoutType.id);
      if(layoutType.hasSubTypes){
        this.initSubStates([
          {
            id: '65b4f1fb-655e-4ebb-b51e-8108081e2f8e',
            code:'layoutSubType',
            name: ''
          }
        ]);
        this.canMoveToNextSubState = layoutType.hasSubTypes;
        this.loadLayoutSubTypePage(1, layoutType.id);
        setTimeout(() => {
          this.nextSubState(this.subState);
        }, 50);        
      }
      else {
        this.initSubStates();
        setTimeout(() => {
          this.moveToNext();
        }, 50);
      }
    }
    //this.calculateEstimate();  
  }
  onLayoutSelected(layoutType:LayoutType){
    this.layoutItem = layoutType;
    if(layoutType){
      this.form.controls['plasardLayoutId'].setValue(layoutType.id);
      this.moveToNext();
    }  
  }  
  selectedDoorIndex = 0;
  onDoorTypeSelected(image:ImageBrowserElement, location:LayoutLocation){    
    let row: FormGroup = null;
    const noOfDoors = this.getNumberOfDoors(location);
    if(image){
      if(location === LayoutLocation.Left){
        row = this.doorsLeft.at(this.selectedDoorIndex) as FormGroup;
      }
      else if(location === LayoutLocation.Right){
        row = this.doorsRight.at(this.selectedDoorIndex) as FormGroup;
      }
      else if(location === LayoutLocation.Center){
        row = this.doorsCenter.at(this.selectedDoorIndex) as FormGroup;
      }
      
      if(row){
        row.controls['plasardDoorTypeId'].setValue(image.elem.id);
        row.controls['plasardDoorType'].setValue(image.elem);
        this.addDoorTypeItem(image.elem.id, <DoorType>image.elem);
        if(this.selectedDoorIndex<noOfDoors-1)
        {
          this.onDoorLayoutIndexSelected(this.selectedDoorIndex+1);
        }
      }
    }  
  }

  onDoorTypeScroll(){
    if(this.doorTypesPage){
      this.reloadInsides(this.doorTypesPage.page+1,true);
    }
  }
  onDoorTypeNextPage(pageInfo: IPageInfo){
    if(pageInfo){
      this.reloadInsides(pageInfo.page+1);
    }
  }
  onDoorTypeRefresh(event:any){
    if(this.doorTypesPage){
      this.reloadInsides(this.doorTypesPage.page);
    }
  }  
  onDoorTypePrevPage(pageInfo: IPageInfo){
    if(pageInfo){
      this.reloadInsides(pageInfo.page-1);
    }
  }    
  onDoorLayoutIndexSelected(index:number) {
    if(this.selectedDoorIndex === index){
      this.selectedDoorIndex = -1;
    }
    else {
      this.selectedDoorIndex = index;
    }    
  }
  onAterSubmit(model:CustomerPortal){    
    this.setState('offer');    
    this.dataService.Get(model.id).subscribe(result => {      
      if(result){
        this.offserSubmitDialogConfig = new MatDialogConfig();
        this.offserSubmitDialogConfig.disableClose = true;
        this.offserSubmitDialogConfig.width = '600px';
        this.offserSubmitDialogConfig.backdropClass = 'sendpdf-backdrop';
        this.offserSubmitDialogConfig.data = {
          title: 'plasardMeasurement.operationExecuting',
          message: 'plasardMeasurement.sendingOffer'      
        };   
        this.offerSubmitDialog = this.dialog.open(OperationExecutingComponent, this.offserSubmitDialogConfig);            
        this.offer = result.payload;        
        setTimeout(() => {
          var skus = this.offer.items.map(item => item.code);
          this.pixel.track("InitiateCheckout", {
            content_ids: skus, // Item SKUs
            value: this.offer.total, // Value of all items
            currency: "EUR", // Currency of the value
          });
          this.pixel.trackCustom("Ponudba", {
            id: this.offer.code,
            email: this.offer.email,
            tel: this.offer.telepohone,
            itemCodes: skus,
            value:  this.offer.total,
            currency: "EUR"
          });
          this.createPdf();
        }, 500);
      }
    })    
    //this.reload();
  }
  onLogStateHistory(){
    //console.log('onLogStateHistory',this.stateHistory.print());    
  }
  onLogForm(obj:any){
  }
  selectedDecorType:DecorType = null;
  selectedDecors:Decor[] = null;
  decorPage:IPageInfo = null;
  decorPageSize:number = 15;
  onDecorTypeChange(event:MatTabChangeEvent) {
    this.onDecorTypeSelected(this.decorTypes[event.index]);
  }
  onDecorSearched(searchPhrase:string){
    if(this.selectedDecorType){
      this.imageSelectorLoading = true;
      let filter:string = `plasardDecorTypeId eq ${this.selectedDecorType.id}`;
      if(searchPhrase){
        filter+=` and contains(name,'${searchPhrase}')`;
      }
      this.decorService.Filter(filter,'itemsSum',null,1,this.decorPageSize).subscribe(result => {
        this.imageSelectorLoading = false;
        if(result){
          this.decorPage = result.pageInfo;
          this.selectedDecors = result.payload;
        }        
      });       
    }
  }
  onDecorTypeSelected(decorType:DecorType){    
    this.selectedDecorType = decorType;
    this.imageSelectorLoading = true;
    this.displayedDecorPages = [];
    if(decorType){
      this.decorService.Filter(`plasardDecorTypeId eq ${this.selectedDecorType.id}`,'itemsSum',null,1,this.decorPageSize).subscribe(result => {
        this.imageSelectorLoading = false;
        if(result){
          this.decorPage = result.pageInfo;
          this.selectedDecors = result.payload;          
          this.displayedDecorPages.push(result.pageInfo.page);
        }        
      }); 
    }
  }

  onDecorScroll(){
    if(this.selectedDecorType && this.decorPage){
      const page = this.decorPage.page + 1;
      this.decorService.Filter(`plasardDecorTypeId eq ${this.selectedDecorType.id}`,'itemsSum',null,page,this.decorPageSize).subscribe(result => {
        this.imageSelectorLoading = false;
        if(result && !this.displayedDecorPages.includes(result.pageInfo.page)){
          this.selectedDecors = this.selectedDecors.concat(result.payload);
          this.decorPage = result.pageInfo;
          this.displayedDecorPages.push(result.pageInfo.page);
        }
      }); 
    }
  }
  onDecorNextPage(pageInfo: IPageInfo){
    if(this.selectedDecorType && this.decorPage){
      this.decorService.Filter(`plasardDecorTypeId eq ${this.selectedDecorType.id}`,'itemsSum',null,this.decorPage.page + 1,this.decorPageSize).subscribe(result => {
        this.imageSelectorLoading = false;
        if(result && !this.displayedDecorPages.includes(result.pageInfo.page)){
          this.decorPage = result.pageInfo;
          this.selectedDecors = result.payload;
        }        
      }); 
    }    
  }
  onDecorRefresh(event:any){
    if(this.selectedDecorType && this.decorPage){
      this.decorService.Filter(`plasardDecorTypeId eq ${this.selectedDecorType.id}`,'itemsSum',null,this.decorPage.page,this.decorPageSize).subscribe(result => {
        this.imageSelectorLoading = false;
        if(result){
          this.decorPage = result.pageInfo;
          this.selectedDecors = result.payload;
        }        
      }); 
    }
  }  
  onDecorPrevPage(pageInfo: IPageInfo){
    if(this.selectedDecorType && this.decorPage){
      this.decorService.Filter(`plasardDecorTypeId eq ${this.selectedDecorType.id}`,'itemsSum',null,this.decorPage.page - 1,this.decorPageSize).subscribe(result => {
        this.imageSelectorLoading = false;
        if(result && result.payload && result.payload.length>0){
          this.decorPage = result.pageInfo;
          this.selectedDecors = result.payload;
        }        
      }); 
    }
  }  
  onDecorSelected(image:ImageBrowserElement, location:LayoutLocation){ 
    const noOfDoors = this.getNumberOfDoors(location);
    const noOfPanels = this.getNumberOfPanels();
    if(image && this.selectedDoorIndex !== null && this.selectedPanelIndex !== null){
      let door:FormGroup = null;
      if(location === LayoutLocation.Left){
        door = <FormGroup>this.doorsLeft.at(this.selectedDoorIndex);
      }
      else if(location === LayoutLocation.Right){
        door = <FormGroup>this.doorsRight.at(this.selectedDoorIndex);
      }
      else if(location === LayoutLocation.Center){
        door = <FormGroup>this.doorsCenter.at(this.selectedDoorIndex);
      }
      let panel = `panel${this.selectedPanelIndex}Id`;
      let item = `item${this.selectedPanelIndex}Id`;
      let container = `panel${this.selectedPanelIndex}Container`;    
      if(door){
        this.addDecorItems(image.elem.id, <Decor>image.elem);
        door.controls[container].setValue(image.file.container);       
        door.controls[panel].setValue(image.file.id);
        door.controls[item].setValue(image.elem.id);
        if(noOfDoors >0 && noOfPanels>0){
          if(this.selectedPanelIndex<noOfPanels)
          {
            this.onSelectedPanel(this.selectedDoorIndex,this.selectedPanelIndex+1);
          }
          else if(this.selectedDoorIndex<noOfDoors-1){
            this.onSelectedPanel(this.selectedDoorIndex+1,1);
          }
        }

        this.cdRef.detectChanges();
      }      
    }
  }
  selectedInsideType:InsideType = null;
  selectedInsides:Inside[] = null;
  selectedInsidePage:IPageInfo = null;    
  selectedInsideIndex = 0;  
  onInsideTypeChange(event:MatTabChangeEvent) {
    this.onInsideTypeSelected(this.insideTypes[event.index]);
  }
  onInsideTypeSelected(insideType:InsideType){    
    this.selectedInsideType = insideType;
    this.selectedInsides = null;
    this.imageSelectorLoading = true;
    if(insideType){
      this.reloadInsides();
    }
  }
  
  addInsideItem(key: string, item: InsideItem){
    this.selectedInsideItems.set(key, item);
  }
  getInsideItem(key: string): InsideItem{
    if(this.selectedInsideItems.has(key)){
      return this.selectedInsideItems.get(key);
    }
    else {
      return null;
    }
  }  
  
  addDoorTypeItem(key: string, item: DoorType){
    this.selectedDoorTypes.set(key, item);
  }
  getDoorTypeItem(key: string): DoorType{
    if(this.selectedDoorTypes.has(key)){
      return this.selectedDoorTypes.get(key);
    }
    else {
      return null;
    }
  }  

  addDecorItems(key: string, item: Decor){
    this.selectedDecorItems.set(key, item);
  }
  getDecorItems(key: string): Decor{
    if(this.selectedDecorItems.has(key)){
      return this.selectedDecorItems.get(key);
    }
    else {
      return null;
    }
  }

  onInsideSelected(image:ImageBrowserElement, location: LayoutLocation){     
    if(image && this.selectedInsideIndex !== null && this.selectedPanelIndex !== null){
      let inside:FormGroup = null;
      let noOfDoors = this.getNumberOfDoors(location);
      if(location === LayoutLocation.Left){
        inside = <FormGroup>this.insidesLeft.at(this.selectedInsideIndex);
      }
      else if(location === LayoutLocation.Right){
        inside = <FormGroup>this.insidesRight.at(this.selectedInsideIndex);
      }
      else if(location === LayoutLocation.Center){
        inside = <FormGroup>this.insidesCenter.at(this.selectedInsideIndex);
      }
      let panel = `panel${this.selectedPanelIndex}Id`;
      let container = `panel${this.selectedPanelIndex}Container`;    
      if(inside){
        inside.controls[container].setValue(image.file.container);       
        inside.controls[panel].setValue(image.file.id);
        inside.controls['insideId'].setValue(image.elem.id);
        this.addInsideItem(image.elem.id, <InsideItem>image.elem);
        if(this.selectedInsideIndex<noOfDoors-1){
          this.onSelectedInsidePanel(this.selectedInsideIndex+1,1);
        }
        this.calculateEstimate();
      }
    }
  }
  onInsideScroll(){
    if(this.selectedInsidePage){
      this.reloadInsides(this.selectedInsidePage.page+1,true);
    }
  }
  onInsideNextPage(pageInfo: IPageInfo){
    if(pageInfo){
      this.reloadInsides(pageInfo.page+1);
    }
  }
  onInsideRefresh(event:any){
    if(this.selectedInsidePage){
      this.reloadInsides(this.selectedInsidePage.page);
    }
  }  
  onInsidePrevPage(pageInfo: IPageInfo){
    if(pageInfo){
      this.reloadInsides(pageInfo.page-1);
    }
  }  
  getDoorTypeLink(door:FormGroup):string{
    let ret:string = null;
    if(door){      
      let panelId = door.controls['plasardDoorType'].value.picture;
      let containerId = door.controls['plasardDoorType'].value.id      
      if(panelId && containerId){
        ret = this.getLink(containerId,panelId);
      }      
    }
    return ret;
  }   
  hasdoorTypePanel(door:FormGroup){
    let ret:boolean = false;
    if(door){
      ret = door.controls['plasardDoorType'].value.id !== null && door.controls['plasardDoorType'].value.picture !== null;
    }
    return ret;
  }      
  hasInsidePanel(insideIndex:number,panelIndex:number, location: LayoutLocation){
    let ret:boolean = false;
    let inside:FormGroup = null;
    if(location === LayoutLocation.Left){
      inside = <FormGroup>this.insidesLeft.at(insideIndex);
    }
    else if(location === LayoutLocation.Right){
      inside = <FormGroup>this.insidesRight.at(insideIndex);
    }
    else if(location === LayoutLocation.Center){
      inside = <FormGroup>this.insidesCenter.at(insideIndex); //this.selectedInsideIndex
    }
    if(inside){
      let panelId = `panel${panelIndex}Id`;
      let panelContainer = `panel${panelIndex}Container`;
      ret = inside.controls[panelId].value !== null && inside.controls[panelContainer].value !== null;
    }
    return ret;  
  }  
  hasPanel(doorIndex:number,panelIndex:number, location:LayoutLocation){
   let ret:boolean = false;
   let door:FormGroup = null;
   if(location === LayoutLocation.Left){
     door = <FormGroup>this.doorsLeft.at(doorIndex);
   }
   else if(location === LayoutLocation.Right){
     door = <FormGroup>this.doorsRight.at(doorIndex);
   }
   else if(location === LayoutLocation.Center){
     door = <FormGroup>this.doorsCenter.at(doorIndex);
   }
   if(door){
     let panelId = `panel${panelIndex}Id`;
     let panelContainer = `panel${panelIndex}Container`;
     ret = door.controls[panelId].value !== null && door.controls[panelContainer].value !== null;
   }
   return ret;
  }  
  getPanelLink(doorIndex:number,panelIndex:number, location:LayoutLocation):string{
    let ret:string = null;
    let door:FormGroup = null;
    if(location === LayoutLocation.Left){
      door = <FormGroup>this.doorsLeft.at(doorIndex);
    }
    else if(location === LayoutLocation.Right){
      door = <FormGroup>this.doorsRight.at(doorIndex);
    }
    else if(location === LayoutLocation.Center){
      door = <FormGroup>this.doorsCenter.at(doorIndex);
    }
    if(door){
      let panel = `panel${panelIndex}Id`;
      let container = `panel${panelIndex}Container`;
      
      let panelId = door.controls[panel].value;
      let containerId = door.controls[container].value      
      if(panelId && containerId){
        ret = this.getLink(containerId,panelId);
      }      
    }
    return ret;
   } 
   getInsidePanelLink(insideIndex:number,panelIndex:number, location: LayoutLocation):string{
    let ret:string = null;
    let inside:FormGroup = null;
    if(location === LayoutLocation.Left){
      inside = <FormGroup>this.insidesLeft.at(insideIndex);
    }
    else if(location === LayoutLocation.Right){
      inside = <FormGroup>this.insidesRight.at(insideIndex);
    }
    else if(location === LayoutLocation.Center){
      inside = <FormGroup>this.insidesCenter.at(insideIndex);
    }

    if(inside){
      let panel = `panel${panelIndex}Id`;
      let container = `panel${panelIndex}Container`;
      
      let panelId = inside.controls[panel].value;
      let containerId = inside.controls[container].value      
      if(panelId && containerId){
        ret = this.getLink(containerId,panelId);
      }
      
    }
    return ret;
   } 

  getLink(container:string, id:string):string{
    let fileInfo:IFileInfo = {
      container: container,
      id:id
    };
    let url:string = this.fileUploadService.GetLink(fileInfo);
    return url?`url(${url})`:null;
  }
  selectedPanelIndex = null;
  onSelectedPanel(doorIndex:number,panelIndex:number){
    if(doorIndex ===  this.selectedDoorIndex && this.selectedPanelIndex === panelIndex){
      this.selectedDoorIndex = -1;
      this.selectedPanelIndex = -1;    
    }
    else {
      this.selectedDoorIndex = doorIndex;
      this.selectedPanelIndex = panelIndex;    
    }
  }
  onSelectedInsidePanel(insideIndex:number,panelIndex:number,force:boolean = false){
    if(this.selectedInsideIndex === insideIndex && this.selectedPanelIndex === panelIndex){
      if(!force){
        this.selectedInsideIndex = -1;
        this.selectedPanelIndex = -1;
      }
    }
    else {
      this.selectedInsideIndex = insideIndex;
      this.selectedPanelIndex = panelIndex;      
      this.reloadInsides();
    }
  }
  onInsideLayoutIndexSelected(index:number) {
    if(this.selectedInsideIndex === index){
      this.selectedInsideIndex = -1;
    }
    else {
      this.selectedInsideIndex = index;
      this.reloadInsides();
    }

  }
  onInsideSearched(searchPhrase:string){
    if(this.selectedInsideType){
      this.reloadInsides(1,false,searchPhrase);
    }
  }
  reloadInsides(page:number = 1, append:boolean = false, searchPhrase:string = null){
    let doornumber = 0;
    let width = 0;
    let depth = 0;
    if(this.insideItemLocation === LayoutLocation.Left){
      doornumber = this.form.get('noOfDoorsLeft').value;
      width = this.form.get('widthLeft').value;
      depth = this.form.get('depthLeft').value;
    }
    else if(this.insideItemLocation === LayoutLocation.Right){
      doornumber = this.form.get('noOfDoorsRight').value;
      width = this.form.get('widthRight').value;
      depth = this.form.get('depthRight').value;
    }
    else if(this.insideItemLocation === LayoutLocation.Center){
      doornumber = this.form.get('noOfDoorsCenter').value;
      width = this.form.get('widthCenter').value;
      depth = this.form.get('depthCenter').value;
    }    

    let positionFilter = this.getlocationFilter(doornumber,width, depth);
    let insideFilter=`plasardInsideTypeId eq ${this.selectedInsideType.id}`;

    if(positionFilter){
      insideFilter+=` and ${positionFilter}`;
    }
    if(searchPhrase){
      insideFilter+=` and contains(name,'${searchPhrase}')`;
    }
    this.insideService.Filter(insideFilter,'name',null,page,this.insidePageSize).subscribe((data)=>{
      if(data){
        if(append && data.payload){
          this.selectedInsides = [...this.selectedInsides,...data.payload]
        }
        else {
          this.selectedInsides = data.payload
        } 
        this.selectedInsidePage = data.pageInfo;
      }
    });
  }
  loadDoorTypes(page:number = 1, append:boolean = false){
    this.doorTypeService.GetAll('code',null,page,9).subscribe((data)=>{
      if(data){
        this.doorTypes = data.payload;
        this.doorTypesPage = data.pageInfo;
        if(this.doorTypes && this.doorTypes.length > 0){
          this.addDoorTypeItem(this.doorTypes[0].id, this.doorTypes[0]);
        }
      }
    })
  }  
  logFrom(){
    console.log('form',this.form);
  }
  doorPanelSet(location:LayoutLocation){
    let ret = true;
    let doors:FormArray = null;
    if(location === LayoutLocation.Left){
      doors = this.doorsLeft;
    }
    else if(location === LayoutLocation.Right){
      doors = this.doorsRight;
    }    
    else if(location === LayoutLocation.Center){
      doors = this.doorsCenter;
    }        
    if(doors && doors.controls){
      for(let i=0;i<doors.controls.length;i++){
        ret = ret && doorPanelSet(doors.controls[i]);
      }
    }
    return ret;
  }
  InsideSet(location:LayoutLocation){
    let ret = true;
    let insides = null;
    if(location === LayoutLocation.Left){
      insides = <FormArray>this.form.get('insidesLeft');
    }
    else if(location === LayoutLocation.Right){
      insides = <FormArray>this.form.get('insidesRight');
    }    
    else if(location === LayoutLocation.Center){
      insides = <FormArray>this.form.get('insidesCenter');
    }    
    if(insides && insides.controls){
      for(let i=0;i<insides.controls.length;i++){
        ret = ret && insidePanelSet(insides.controls[i]);
      }
    }
    return ret;
  }
  setDoorCount(location:string, value:number){    
    const list:number[] = [];
    //65 -> floor(ŠIRINA/65) = 3
    let min = Math.ceil(value/115); 
    let max = Math.floor(value/65);         
    if(min < 1){
      min = 1;
    }

    let def = null;
    if(max > 5){
      max = 5;
    }
    if(min <= max){
      def = min;
      if(min+1<max){
        def = min+1;
      }
    }    
    for(let i = min; i<=max;i++){
      list.push(i);
    }
    if(location === DoorLocation.Left){
      this.doorCountLeft = list;
      this.form.get('noOfDoorsLeft').setValue(def);
    }
    else if(location === DoorLocation.Center){
      this.doorCountCenter = list;
      this.form.get('noOfDoorsCenter').setValue(def);
    }
    else if(location === DoorLocation.Right){
      this.doorCountRight = list;
      this.form.get('noOfDoorsRight').setValue(def);
    }    
  }
  onDoorCountSelected(location:string, value:string){
    if(location === DoorLocation.Left){
      this.form.get('noOfDoorsLeft').setValue(value);
    }
    else if(location === DoorLocation.Center){
      this.form.get('noOfDoorsCenter').setValue(value);
    }
    else if(location === DoorLocation.Right){
      this.form.get('noOfDoorsRight').setValue(value);
    }        
  }
  loadImage(url) {
    return new Promise((resolve) => {
      let img = new Image();
      img.onload = () => resolve(img);
      img.src = url;
    })
  }
  calculateEstimate(){
    var estimate = 0;
    if(this.layoutTypeItem) {
      estimate = this.layoutTypeItem.itemPrice;
    }
    else if(this.layoutSubTypeItem && this.layoutSubTypeItem.itemPrice){
      estimate = this.layoutSubTypeItem.itemPrice;
    }
      // measurments
      let height=0;
      let width=0;
      if(this.dimensionsLayout){
        if (this.dimensionsLayout.none || this.dimensionsLayout.left > 0) {
          height = this.form.controls['heightLeft'].value;
        }
        else if(this.dimensionsLayout.center > 0){
          height = this.form.controls['heightCenter'].value;
        }
        else if(this.dimensionsLayout.right > 0){
          height = this.form.controls['heightRight'].value;
        }

        if(this.dimensionsLayout.left > 0){
          width = this.form.controls['widthLeft'].value;
        }
        else if(this.dimensionsLayout.center > 0){
          width = this.form.controls['widthCenter'].value;
        }
        else if(this.dimensionsLayout.right > 0){
          width = this.form.controls['widthRight'].value;
        }

      const surfaceArea = (width / 100) * (height / 100);
      estimate = estimate * (width / 100) * (height / 100);

      // insides
      const insideCenter = this.calculateInsideSidePrice(LayoutLocation.Center);
      const insideLeft = this.calculateInsideSidePrice(LayoutLocation.Left);
      const insideRight = this.calculateInsideSidePrice(LayoutLocation.Right);      
      estimate += insideCenter;
      estimate += insideLeft;
      estimate += insideRight;

      // decors      
      const isPastDecors = this.state === 'outside' || this.state === 'customerInfo' || this.state === 'customerInfo' || this.state === 'finish'
      const doorCenter = this.calculateDecorPrice(LayoutLocation.Center, surfaceArea);
      const doorLeft = this.calculateDecorPrice(LayoutLocation.Left, surfaceArea);
      const doorRight = this.calculateDecorPrice(LayoutLocation.Right, surfaceArea);

      if(isPastDecors){
        estimate = insideCenter + insideLeft + insideRight;
        estimate += doorCenter;
        estimate += doorLeft;
        estimate += doorRight;
      }
    }
    if(this.state === 'layoutType' || this.state === 'layout'){
      this.esstimate = 0;
    }
    else {
      this.esstimate = estimate;
    }    
  }
  calculateInsideSidePrice(location:LayoutLocation): number {
    // aaa
    let ret = 0;
    let noOfDoors = this.getNumberOfDoors(location);
    if(noOfDoors < 1) {
      return ret;
    }
    let insides: FormArray = null;
    if(location === LayoutLocation.Left){
      insides = this.insidesLeft;
    }
    else if(location === LayoutLocation.Right){
      insides = this.insidesRight;
    }
    else if(location === LayoutLocation.Center){
      insides = this.insidesCenter;
    }
    if(!insides){
      return ret;
    }
    for(let d = 0;d<noOfDoors;d++){
      const inside:FormGroup = <FormGroup>insides.at(d);
      if(inside){
        const insideId = inside.controls['insideId'].value;
        const insideItem = this.getInsideItem(insideId);
        if(insideItem){
          ret += insideItem.itemPrice;
        }
      }
    }

    return ret;
  }

  calculateDecorPrice(location:LayoutLocation, surfaceArea:number): number {
    // bbb
    let ret = 0;    
    let noOfDoors = this.getNumberOfDoors(location);
    if(noOfDoors < 1) {
      return ret;
    }
    
    let doors: FormArray = null;
    if(location === LayoutLocation.Left){
      doors = this.doorsLeft;
    }
    else if(location === LayoutLocation.Right){
      doors = this.doorsRight;
    }
    else if(location === LayoutLocation.Center){
      doors = this.doorsCenter;
    }
    if(!doors){
      return ret;
    }
    
    for(let d = 0;d<noOfDoors;d++){
      const door:FormGroup = <FormGroup>doors.at(d);
      if(door){
        var doorTypeId = door.controls['plasardDoorTypeId'].value;
        if(doorTypeId){
          const doorTypeItem = this.getDoorTypeItem(doorTypeId);
          if(doorTypeItem){
            // bbb
            for(let dec = 0;dec<5;dec++){
              const decorIndex = dec+1;
              const decorKey = `item${decorIndex}Id`
              const decorId = door.controls[decorKey].value;
              let factor = 0;
              if(doorTypeItem.code === '0' && decorIndex === 1){
                factor = doorTypeItem.factor1;
              }
              else if(doorTypeItem.code === '1' && decorIndex === 1){
                factor = doorTypeItem.factor4;
              }
              else if(doorTypeItem.code === '1' && decorIndex === 2){
                factor = doorTypeItem.factor5;
              }
              else if(doorTypeItem.code === '2' && decorIndex === 1){
                factor = doorTypeItem.factor1;
              }
              else if(doorTypeItem.code === '2' && decorIndex === 2){
                factor = doorTypeItem.factor4;
              }
              else if(doorTypeItem.code === '2' && decorIndex === 3){
                factor = doorTypeItem.factor5;
              }
              else if(doorTypeItem.code === '3' && decorIndex === 1){
                factor = doorTypeItem.factor1;
              }
              else if(doorTypeItem.code === '3' && decorIndex === 2){
                factor = doorTypeItem.factor4;
              }
              else if(doorTypeItem.code === '3' && decorIndex === 3){
                factor = doorTypeItem.factor5;
              }
              else if(doorTypeItem.code === '4' && decorIndex === 1){
                factor = doorTypeItem.factor4;
              }
              else if(doorTypeItem.code === '4' && decorIndex === 2){
                factor = doorTypeItem.factor2;
              }
              else if(doorTypeItem.code === '4' && decorIndex === 3){
                factor = doorTypeItem.factor1;
              }
              else if(doorTypeItem.code === '4' && decorIndex === 4){
                factor = doorTypeItem.factor3;
              }
              else if(doorTypeItem.code === '4' && decorIndex === 5){
                factor = doorTypeItem.factor5;
              }
              else if(doorTypeItem.code === '5' && decorIndex === 1){
                factor = doorTypeItem.factor4;
              }
              else if(doorTypeItem.code === '5' && decorIndex === 2){
                factor = doorTypeItem.factor2;
              }
              else if(doorTypeItem.code === '5' && decorIndex === 3){
                factor = doorTypeItem.factor1;
              }
              else if(doorTypeItem.code === '5' && decorIndex === 4){
                factor = doorTypeItem.factor3;
              }
              else if(doorTypeItem.code === '5' && decorIndex === 5){
                factor = doorTypeItem.factor5;
              }
              if(decorId){
                const decor = this.getDecorItems(decorId);
                if(decor && factor !== 0){
                  ret += ((surfaceArea / noOfDoors) * decor.itemPrice * factor);
                }
              }
              else { // default value
                ret += ((surfaceArea / noOfDoors) * 220 * factor);
              }
            }
          }
        }
      }
    }

    return ret;
  }
}

function insidePanelSet(inside:any){
  return inside && inside.value && inside.value.insideId;
}

function doorPanelSet(door:any){
  const code = door.value.plasardDoorType.code;
  let ret = true;
  switch(code){
    case '0':
      ret = door.value.panel1Id && door.value.panel1Container;
      break;
    case '1':
      ret = door.value.panel1Id && door.value.panel1Container && 
            door.value.panel2Id && door.value.panel2Container;
      break;
    case '2':
      ret = door.value.panel1Id && door.value.panel1Container && 
            door.value.panel3Id && door.value.panel3Container && 
            door.value.panel2Id && door.value.panel2Container;              
      break;
    case '3':
      ret = door.value.panel1Id && door.value.panel1Container && 
            door.value.panel3Id && door.value.panel3Container && 
            door.value.panel2Id && door.value.panel2Container;              
      break;
    case '4':
      ret = door.value.panel1Id && door.value.panel1Container && 
            door.value.panel3Id && door.value.panel3Container && 
            door.value.panel4Id && door.value.panel4Container && 
            door.value.panel5Id && door.value.panel5Container && 
            door.value.panel2Id && door.value.panel2Container;              
      break;            
    case '4':
      ret = door.value.panel1Id && door.value.panel1Container && 
            door.value.panel3Id && door.value.panel3Container && 
            door.value.panel4Id && door.value.panel4Container && 
            door.value.panel5Id && door.value.panel5Container && 
            door.value.panel2Id && door.value.panel2Container;              

      break;
  
  }    
  return ret;
}

export class DimentionsLayout {
  left:number;
  right:number;
  center:number
  constructor(left:number, right:number, center:number){
    this.left = left;
    this.right = right;
    this.center = center;
  }
  get none():boolean{
    return !(this.left || this.right || this.center);
  }
}
export enum DoorLocation {
  Left = 'left',
  Center = 'center',
  Right = 'right'
}